var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E81717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5725C9 15.7637 9.20591 15.8842 9.37256 15.7904L16.6126 11.7179C16.7825 11.6224 16.7825 11.3777 16.6126 11.2821L9.37257 7.20957C9.20591 7.11583 9 7.23626 9 7.42746V15.5725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeRed);
export default __webpack_public_path__ + "static/media/youtube_red.5f4f7447841efd58c0dd62948cb83230.svg";
export { ForwardRef as ReactComponent };